import type { OnboardingStepId } from './onboarding-checklist-storage';

export type OnboardingStepDef = {
  id: OnboardingStepId;
  label: string;
  /** נתיב ב-router */
  path: string;
  /** query string כולל ? */
  search?: string;
};

export const ONBOARDING_STEPS: OnboardingStepDef[] = [
  {
    id: 'accountSetup',
    label: 'פתיחת חשבון ב Funner',
    path: '/users',
  },
  {
    id: 'whatsapp',
    label: 'חשבון ומספר וואטסאפ',
    path: '/system-settings/facebook-notifications',
  },
  {
    id: 'firstConversation',
    label: 'התכתבות ראשונה',
    path: '/chats',
  },
  {
    id: 'company',
    label: 'בניית זהות העסק',
    path: '/company/details',
  },
  {
    id: 'geminiAi',
    label: 'הגדרת טוקן AI (Gemini)',
    path: '/system-settings/connections',
  },
  {
    id: 'users',
    label: 'מזמינים את הצוות למערכת',
    path: '/users',
  },
  {
    id: 'contacts',
    label: 'מייבאים את הלקוחות הראשונים',
    path: '/contacts/chat',
  },
  {
    id: 'template',
    label: 'מגישים את התבנית הראשונה',
    path: '/templates/create',
  },
];

export function stepToHref(step: OnboardingStepDef): string {
  return `${step.path}${step.search ?? ''}`;
}

export function getStepHrefById(id: OnboardingStepId): string {
  const step = ONBOARDING_STEPS.find((s) => s.id === id);
  return step ? stepToHref(step) : '/chats';
}
